var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SignatureTrackAdapter_instances, _SignatureTrackAdapter_terminator, _SignatureTrackAdapter_context, _SignatureTrackAdapter_signature, _SignatureTrackAdapter_signatureTrack, _SignatureTrackAdapter_adapters, _SignatureTrackAdapter_ppqnToBar, _SignatureTrackAdapter_findSignatureEventAt;
import { isNull, Notifier, Terminator, UUID } from "@opendaw/lib-std";
import { PPQN } from "@opendaw/lib-dsp";
import { SignatureEventBoxAdapter } from "./SignatureEventBoxAdapter";
import { SignatureEventBox } from "@opendaw/studio-boxes";
import { IndexedBoxAdapterCollection } from "../IndexedBoxAdapterCollection";
import { Pointers } from "@opendaw/studio-enums";
export class SignatureTrackAdapter {
    constructor(context, signature, signatureTrack) {
        _SignatureTrackAdapter_instances.add(this);
        _SignatureTrackAdapter_terminator.set(this, new Terminator());
        _SignatureTrackAdapter_context.set(this, void 0);
        _SignatureTrackAdapter_signature.set(this, void 0);
        _SignatureTrackAdapter_signatureTrack.set(this, void 0);
        _SignatureTrackAdapter_adapters.set(this, void 0);
        __classPrivateFieldSet(this, _SignatureTrackAdapter_context, context, "f");
        __classPrivateFieldSet(this, _SignatureTrackAdapter_signature, signature, "f");
        __classPrivateFieldSet(this, _SignatureTrackAdapter_signatureTrack, signatureTrack, "f");
        this.changeNotifier = new Notifier();
        __classPrivateFieldSet(this, _SignatureTrackAdapter_adapters, __classPrivateFieldGet(this, _SignatureTrackAdapter_terminator, "f").own(IndexedBoxAdapterCollection.create(__classPrivateFieldGet(this, _SignatureTrackAdapter_signatureTrack, "f").events, box => context.boxAdapters.adapterFor(box, SignatureEventBoxAdapter), Pointers.SignatureAutomation)), "f");
        __classPrivateFieldGet(this, _SignatureTrackAdapter_terminator, "f").ownAll(__classPrivateFieldGet(this, _SignatureTrackAdapter_signature, "f").subscribe(() => this.dispatchChange()), __classPrivateFieldGet(this, _SignatureTrackAdapter_signatureTrack, "f").enabled.subscribe(() => this.dispatchChange()), __classPrivateFieldGet(this, _SignatureTrackAdapter_adapters, "f").subscribe({
            onAdd: (_adapter) => this.changeNotifier.notify(),
            onRemove: (_adapter) => this.changeNotifier.notify(),
            onReorder: (_adapter) => this.changeNotifier.notify()
        }));
    }
    subscribe(observer) { return this.changeNotifier.subscribe(observer); }
    get context() { return __classPrivateFieldGet(this, _SignatureTrackAdapter_context, "f"); }
    get enabled() { return __classPrivateFieldGet(this, _SignatureTrackAdapter_signatureTrack, "f").enabled.getValue(); }
    get object() { return __classPrivateFieldGet(this, _SignatureTrackAdapter_signatureTrack, "f"); }
    get size() { return __classPrivateFieldGet(this, _SignatureTrackAdapter_adapters, "f").size(); }
    get storageSignature() {
        const { nominator, denominator } = __classPrivateFieldGet(this, _SignatureTrackAdapter_signature, "f");
        return [nominator.getValue(), denominator.getValue()];
    }
    nonEmpty() { return __classPrivateFieldGet(this, _SignatureTrackAdapter_adapters, "f").size() > 0; }
    /** @internal */
    dispatchChange() { this.changeNotifier.notify(); }
    signatureAt(position) {
        position = Math.max(0, position);
        let result = this.storageSignature;
        for (const { accumulatedPpqn, nominator, denominator } of this.iterateAll()) {
            if (accumulatedPpqn > position) {
                break;
            }
            result = [nominator, denominator];
        }
        return result;
    }
    *iterateAll() {
        let accumulatedPpqn = 0;
        let accumulatedBars = 0;
        let [nominator, denominator] = this.storageSignature;
        yield { index: -1, accumulatedPpqn, accumulatedBars, nominator, denominator };
        if (!__classPrivateFieldGet(this, _SignatureTrackAdapter_signatureTrack, "f").enabled.getValue()) {
            return;
        }
        for (const adapter of __classPrivateFieldGet(this, _SignatureTrackAdapter_adapters, "f").adapters()) {
            accumulatedPpqn += PPQN.fromSignature(nominator, denominator) * adapter.relativePosition;
            accumulatedBars += adapter.relativePosition;
            nominator = adapter.nominator;
            denominator = adapter.denominator;
            yield { index: adapter.index, accumulatedPpqn, accumulatedBars, nominator, denominator };
        }
    }
    changeSignature(nominator, denominator) {
        const originalEvents = Array.from(this.iterateAll()).slice(1);
        const originalPositions = originalEvents.map(e => e.accumulatedPpqn);
        __classPrivateFieldGet(this, _SignatureTrackAdapter_signature, "f").nominator.setValue(nominator);
        __classPrivateFieldGet(this, _SignatureTrackAdapter_signature, "f").denominator.setValue(denominator);
        // Recalculate each event's relativePosition to preserve approximate absolute positions.
        let accumulatedPpqn = 0.0;
        let accumulatedFraction = 0.0;
        let durationBar = PPQN.fromSignature(nominator, denominator);
        for (let i = 0; i < originalEvents.length; i++) {
            const event = originalEvents[i];
            const adapter = this.adapterAt(event.index);
            if (adapter.isEmpty()) {
                continue;
            }
            const targetPpqn = originalPositions[i];
            const barsFrac = (targetPpqn - accumulatedPpqn) / durationBar;
            const barsInt = Math.floor(barsFrac);
            const fraction = barsFrac - barsInt;
            accumulatedFraction += fraction;
            let relativePosition = barsInt;
            if (accumulatedFraction >= 1.0) {
                relativePosition++;
                accumulatedFraction--;
            }
            relativePosition = Math.max(1, relativePosition);
            adapter.unwrap().box.relativePosition.setValue(relativePosition);
            accumulatedPpqn += relativePosition * durationBar;
            durationBar = PPQN.fromSignature(event.nominator, event.denominator);
        }
    }
    deleteAdapter(adapter) {
        const deleteIndex = adapter.index;
        const allEvents = Array.from(this.iterateAll()).slice(1);
        const deleteEventIndex = allEvents.findIndex(e => e.index === deleteIndex);
        if (deleteEventIndex === -1) {
            return;
        }
        // Capture original ppqn positions of events AFTER the deleted one
        const eventsAfter = allEvents.slice(deleteEventIndex + 1);
        const originalPositions = eventsAfter.map(e => e.accumulatedPpqn);
        // Determine the signature that will precede the remaining events
        const prevEvent = deleteEventIndex > 0 ? allEvents[deleteEventIndex - 1] : null;
        const [prevNom, prevDenom] = prevEvent !== null
            ? [prevEvent.nominator, prevEvent.denominator]
            : this.storageSignature;
        const prevAccumulatedPpqn = prevEvent !== null ? prevEvent.accumulatedPpqn : 0.0;
        adapter.box.delete();
        // Recalculate relativePositions for events after the deleted one using round()
        let accumulatedPpqn = prevAccumulatedPpqn;
        let durationBar = PPQN.fromSignature(prevNom, prevDenom);
        for (let i = 0; i < eventsAfter.length; i++) {
            const event = eventsAfter[i];
            const eventAdapter = this.adapterAt(event.index);
            if (eventAdapter.isEmpty()) {
                continue;
            }
            const targetPpqn = originalPositions[i];
            const exactBars = (targetPpqn - accumulatedPpqn) / durationBar;
            const relativePosition = Math.max(1, Math.round(exactBars));
            eventAdapter.unwrap().box.relativePosition.setValue(relativePosition);
            accumulatedPpqn += relativePosition * durationBar;
            durationBar = PPQN.fromSignature(event.nominator, event.denominator);
        }
    }
    createEvent(position, nominator, denominator) {
        const allEvents = Array.from(this.iterateAll());
        let prevEvent = allEvents[0];
        let insertAfterIndex = 0;
        for (let i = 1; i < allEvents.length; i++) {
            if (allEvents[i].accumulatedPpqn > position) {
                break;
            }
            prevEvent = allEvents[i];
            insertAfterIndex = i;
        }
        const prevBarPpqn = PPQN.fromSignature(prevEvent.nominator, prevEvent.denominator);
        const barsFromPrev = (position - prevEvent.accumulatedPpqn) / prevBarPpqn;
        const newRelativePosition = Math.max(1, Math.round(barsFromPrev));
        const newIndex = prevEvent.index + 1;
        const successorEvents = allEvents.slice(insertAfterIndex + 1);
        const newEventPpqn = prevEvent.accumulatedPpqn + newRelativePosition * prevBarPpqn;
        const newBarPpqn = PPQN.fromSignature(nominator, denominator);
        const adaptersToUpdate = successorEvents
            .map(event => ({ event, adapter: this.adapterAt(event.index) }))
            .filter(({ adapter }) => adapter.nonEmpty())
            .map(({ event, adapter }) => ({ event, adapter: adapter.unwrap() }));
        for (let i = 0; i < adaptersToUpdate.length; i++) {
            const { event, adapter } = adaptersToUpdate[i];
            adapter.box.index.setValue(event.index + 1);
            if (i === 0) {
                const barsToNext = (event.accumulatedPpqn - newEventPpqn) / newBarPpqn;
                adapter.box.relativePosition.setValue(Math.max(1, Math.round(barsToNext)));
            }
        }
        SignatureEventBox.create(__classPrivateFieldGet(this, _SignatureTrackAdapter_context, "f").boxGraph, UUID.generate(), box => {
            box.index.setValue(newIndex);
            box.relativePosition.setValue(newRelativePosition);
            box.nominator.setValue(nominator);
            box.denominator.setValue(denominator);
            box.events.refer(__classPrivateFieldGet(this, _SignatureTrackAdapter_signatureTrack, "f").events);
        });
    }
    adapterAt(index) { return __classPrivateFieldGet(this, _SignatureTrackAdapter_adapters, "f").getAdapterByIndex(index); }
    moveEvent(adapter, targetPpqn) {
        const allEvents = Array.from(this.iterateAll()).slice(1);
        const movedIdx = allEvents.findIndex(e => e.index === adapter.index);
        if (movedIdx === -1) {
            return;
        }
        const movedEvent = allEvents[movedIdx];
        if (targetPpqn === movedEvent.accumulatedPpqn) {
            return;
        }
        const originalBars = allEvents.map(e => e.accumulatedBars);
        const targetBar = __classPrivateFieldGet(this, _SignatureTrackAdapter_instances, "m", _SignatureTrackAdapter_ppqnToBar).call(this, targetPpqn, movedEvent.index);
        if (targetBar === movedEvent.accumulatedBars) {
            return;
        }
        const newBars = [...originalBars];
        newBars[movedIdx] = targetBar;
        const sortedIndices = newBars
            .map((bar, i) => ({ bar, i }))
            .sort((a, b) => a.bar - b.bar)
            .map(x => x.i);
        const adapters = allEvents.map(e => this.adapterAt(e.index).unwrap("adapterAt"));
        for (let newIdx = 0; newIdx < sortedIndices.length; newIdx++) {
            adapters[sortedIndices[newIdx]].box.index.setValue(newIdx);
        }
        let prevBar = 0;
        for (let i = 0; i < sortedIndices.length; i++) {
            const origIdx = sortedIndices[i];
            const eventAdapter = adapters[origIdx];
            const bar = newBars[origIdx];
            const relPos = Math.max(1, bar - prevBar);
            eventAdapter.box.relativePosition.setValue(relPos);
            prevBar = bar;
        }
    }
    floorToBar(position) {
        const { event, barPpqn } = __classPrivateFieldGet(this, _SignatureTrackAdapter_instances, "m", _SignatureTrackAdapter_findSignatureEventAt).call(this, position);
        const barsFromEvent = Math.floor((position - event.accumulatedPpqn) / barPpqn);
        return event.accumulatedPpqn + barsFromEvent * barPpqn;
    }
    ceilToBar(position) {
        const { event, barPpqn } = __classPrivateFieldGet(this, _SignatureTrackAdapter_instances, "m", _SignatureTrackAdapter_findSignatureEventAt).call(this, position);
        const barsFromEvent = Math.ceil((position - event.accumulatedPpqn) / barPpqn);
        return event.accumulatedPpqn + barsFromEvent * barPpqn;
    }
    roundToBar(position) {
        const { event, barPpqn } = __classPrivateFieldGet(this, _SignatureTrackAdapter_instances, "m", _SignatureTrackAdapter_findSignatureEventAt).call(this, position);
        const barsFromEvent = Math.round((position - event.accumulatedPpqn) / barPpqn);
        return event.accumulatedPpqn + barsFromEvent * barPpqn;
    }
    toParts(position) {
        const { event } = __classPrivateFieldGet(this, _SignatureTrackAdapter_instances, "m", _SignatureTrackAdapter_findSignatureEventAt).call(this, position);
        const parts = PPQN.toParts(position - event.accumulatedPpqn, event.nominator, event.denominator);
        return { ...parts, bars: parts.bars + event.accumulatedBars };
    }
    barLengthAt(position) {
        const [nom, denom] = this.signatureAt(position);
        return PPQN.fromSignature(nom, denom);
    }
    getBarInterval(position) {
        const { event, barPpqn } = __classPrivateFieldGet(this, _SignatureTrackAdapter_instances, "m", _SignatureTrackAdapter_findSignatureEventAt).call(this, position);
        const barsFromEvent = Math.floor((position - event.accumulatedPpqn) / barPpqn);
        const start = event.accumulatedPpqn + barsFromEvent * barPpqn;
        return { position: start, complete: start + barPpqn };
    }
    terminate() { __classPrivateFieldGet(this, _SignatureTrackAdapter_terminator, "f").terminate(); }
}
_SignatureTrackAdapter_terminator = new WeakMap(), _SignatureTrackAdapter_context = new WeakMap(), _SignatureTrackAdapter_signature = new WeakMap(), _SignatureTrackAdapter_signatureTrack = new WeakMap(), _SignatureTrackAdapter_adapters = new WeakMap(), _SignatureTrackAdapter_instances = new WeakSet(), _SignatureTrackAdapter_ppqnToBar = function _SignatureTrackAdapter_ppqnToBar(position, excludeIndex) {
    let prevEvent = null;
    for (const event of this.iterateAll()) {
        if (event.index === excludeIndex) {
            continue;
        }
        if (event.accumulatedPpqn > position) {
            break;
        }
        prevEvent = event;
    }
    if (isNull(prevEvent)) {
        const [nom, denom] = this.storageSignature;
        const barPpqn = PPQN.fromSignature(nom, denom);
        return Math.max(1, Math.round(position / barPpqn));
    }
    const barPpqn = PPQN.fromSignature(prevEvent.nominator, prevEvent.denominator);
    const barsFromEvent = Math.round((position - prevEvent.accumulatedPpqn) / barPpqn);
    return Math.max(1, prevEvent.accumulatedBars + barsFromEvent);
}, _SignatureTrackAdapter_findSignatureEventAt = function _SignatureTrackAdapter_findSignatureEventAt(position) {
    let prevEvent = null;
    for (const event of this.iterateAll()) {
        if (event.accumulatedPpqn > position) {
            break;
        }
        prevEvent = event;
    }
    if (isNull(prevEvent)) {
        const [nominator, denominator] = this.storageSignature;
        return {
            event: { index: -1, accumulatedPpqn: 0, accumulatedBars: 0, nominator, denominator },
            barPpqn: PPQN.fromSignature(nominator, denominator)
        };
    }
    return {
        event: prevEvent,
        barPpqn: PPQN.fromSignature(prevEvent.nominator, prevEvent.denominator)
    };
};
